<template>
    <span>
        <v-navigation-drawer app v-model="drawer" class="white" dark disable-resize-watcher>
            <v-list>
                <template v-for="(item, index) in items">
                    <v-list-item :key="index" :to="item.url">
                        <v-list-item-content
                            style="color: black; font-size: 1.5rem;"
                        >{{ item.title }}</v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`divider-${index}`"></v-divider>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar app flat height="100px" color="white">
            <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-spacer class="hidden-md-and-up"></v-spacer>
            <router-link to="/">
                <v-toolbar-title>
                    <img src="../assets/img/logo.svg" alt height="70px;" class="ml-5" />
                </v-toolbar-title>
            </router-link>
            <v-spacer class="hidden-sm-and-down"></v-spacer>
            <div class="hidden-sm-and-down text-none">
                <template v-for="(item, index) in items">
                    <v-btn
                        text
                        :key="index"
                        :to="item.url"
                        :href="item.href"
                        class="text-none font-normal"
                    >{{ item.title }}</v-btn>
                </template>
                <!-- <v-btn flat to="/sign-in" class="text-none">Sign in</v-btn>
                <v-btn color="blue lighten-3" class="text-none" to="/join"
                    >Join</v-btn
                >-->
            </div>
        </v-app-bar>
    </span>
</template>

<script>
export default {
    name: 'AppNavigation',
    data() {
        return {
            appTitle: 'Project Athena',
            drawer: false,
            items: [
                { title: 'Home', url: '/' },
                { title: 'About', url: '/about' },
                { title: 'How it works', url: '/how-it-works' },
                { title: 'Projects', url: '/projects' },
                {
                    title: 'Survey',
                    href: 'https://survey.athena-project.life'
                },
                { title: 'Join', url: '/join' }
            ]
        };
    },
    computed: {},
    methods: {}
};
</script>

<style scoped>
@import '../assets/styles/variables.scss';
@import '../assets/styles/main.css';
a {
    color: white;
    text-decoration: none;
}
</style>
